import { render, staticRenderFns } from "./AmpliacionReduccionImportView.vue?vue&type=template&id=810ea49a&"
import script from "./AmpliacionReduccionImportView.vue?vue&type=script&lang=js&"
export * from "./AmpliacionReduccionImportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports